// extracted by mini-css-extract-plugin
export default {"root":"SelectedUsers_root__imQ5p"};